import { AbacoWebModule } from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";

export const MODULE_ID = "tos_module";

export type ValueByLanguage =
    | string
    | {
          it: string;
          en: string;
      };

interface TosConfig {
    owner: string;
    ownerWithoutSpa: string;
    serviceName: string;
    ownerAddress: string;
    externalOwner: ValueByLanguage;
    pec: string;
}

interface CookieConfig {
    owner: string;
    serviceName: string;
}

interface PrivacyConfig {
    owner: string;
    serviceName: string;
    ownerFull: string;
    ownerMail: string;
    ownerMobile: string;
    ownerVAT: string;
}

export interface DocTemplateConfig {
    tos: TosConfig;
    privacyPolicy: PrivacyConfig;
    cookiePolicy: CookieConfig;
}

export default class TosModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly forceTopLevelRoutes = true;
    readonly globalComponents = globals;

    defaultConfig: DocTemplateConfig = {
        tos: {
            owner: "Abaco Spa",
            ownerWithoutSpa: "Abaco",
            serviceName: "Abaco Farmer",
            ownerAddress: "Piazza Vilfredo Pareto 9, 46040 Mantova (MN)",
            externalOwner: "Abaco",
            pec: "abaco.mantova@pec.it",
        },
        privacyPolicy: {
            owner: "Abaco Spa",
            serviceName: "Abaco Farmer",
            ownerFull: "ABACO S.P.A., Piazza Vilfredo Pareto 9, 46040 Mantova (MN)",
            ownerMail: "privacy@Abacogroup.eu",
            ownerMobile: "+39 0376222181",
            ownerVAT: "01588630200",
        },
        cookiePolicy: {
            owner: "Abaco Spa",
            serviceName: "Abaco Farmer",
        },
    };
}
